// extracted by mini-css-extract-plugin
export default {"innerWrapper":"aq-z","tooltipWrapper":"bq-z","icon":"cq-z","tooltip":"dq-z","content":"eq-z"};